import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TTPAuditPacketsResponse } from './types';

/**
 * Lists the audit packets the caller can reach, optionally narrowed to one company.
 *
 * Omitting `companyId` keeps the key at the bare `'tp-audit-packet'` string, so callers that want the
 * whole list share one cache entry with every other such caller rather than splitting off their own.
 */
export function useTPAuditPackets(companyId?: number | null) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TTPAuditPacketsResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? `tp-audit-packet?companyId=${companyId}` : 'tp-audit-packet',
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
